import { useState, useCallback } from "react";

export default function useApi(apiFunction) {
  const [isLoading, setIsLoading] = useState(false);

  const trigger = useCallback(
    async (...args) => {
      setIsLoading(true);
      try {
        const response = await apiFunction(...args);
        return response;
      } catch (error) {
        console.error("API error:", error);
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    [apiFunction]
  );

  return { trigger, isLoading };
}
